import * as React from 'react';
import { HighlightedTextRegion } from './highlightDisplayText';
import { isFeatureEnabled } from 'owa-feature-flags';
const searchSuggestionStyles = require('../components/suggestionsCallout/SearchSuggestion.scss');

export default function getHighlightedTextForSuggestion(
    regions: HighlightedTextRegion[],
    shouldHighlight: boolean = true
) {
    // There is no highlighting in this treatment
    if (isFeatureEnabled('sea-suggestionBolding4')) {
        shouldHighlight = false;
    }

    // In order to invert the hit highlighting in the reverse bolding feature
    // we need to make sure that there is at least 1 region that should be highlighted
    // or else we will bold the entire suggestion in zero query
    const countOfHighlightRegions = regions.filter(e => e.text.length > 0 && e.isHighlighted)
        .length;
    const shouldReverseHighlight =
        (isFeatureEnabled('sea-suggestionBolding1') ||
            isFeatureEnabled('sea-suggestionBolding3')) &&
        countOfHighlightRegions > 0;
    return regions
        .filter(e => e.text.length > 0)
        .map((e, i) => {
            const shouldHighlightThisRegion = shouldHighlight
                ? shouldReverseHighlight
                    ? !e.isHighlighted
                    : e.isHighlighted
                : false;
            const className = shouldHighlightThisRegion
                ? searchSuggestionStyles.keywordMatchSuggestion
                : searchSuggestionStyles.keywordNonMatchSuggestion;
            return (
                <div className={className} key={i}>
                    {e.text}
                </div>
            );
        });
}
